import React, {
	//useState,
	//useEffect,
	//useMemo,
} from 'react';

// import {
// 	useSelector,
// 	useDispatch
// } from 'react-redux';

import { GenericListSelect } from './genericListSelect.js';

export const AnimalAgeSelect = (props) => {

	const types = [
		'Calves',
		'Weaners',
		'Yearlings',
		'Young Adults',
		'Mature Adults',
	]

	return (
		<>
			<GenericListSelect
				id = 'Age'
				label = 'Age'
				dataArray = { types }
				cols = { props.cols }
				controlStyle = { props.controlStyle }
				handleChange = {(evt) => props.handleChange(evt)}
				value = { props.value }
				required = { props.required }
				//pattern = {'^\d+$'}	// integer
				pattern = {'^[a-zA-Z]+[a-zA-Z]+$'}
				invalidMsg = 'Select Animal age!'
				lock = { props.lock }
			/>
		</>
	)

}